import React from "react";
import clsx from "clsx";

import { FaqCategoryItem } from "../../types";
import styles from "../FaqCategoryItems.module.scss";

const studentLoginUrl = `${process.env.REACT_APP_STUDENT_DLP_URL}/st/login`;

const Answer = () => (
  <div className={styles.answer}>
    <div className={styles.head}>
      <span className={styles.icon}>A</span>
      <p className={styles.text}>以下を順にご確認ください。</p>
    </div>
    <ul className={clsx(styles.list, styles.number)}>
      <li className={styles.item}>
        正しいページにアクセスしているか
        <br />
        生徒ログイン画面URL(
        <a
          className={styles.link}
          href={studentLoginUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {studentLoginUrl}
        </a>
        )
        <br />
        ※先生用と生徒用で、ログイン画面のURLが異なります。
      </li>
      <li className={styles.item}>
        ログインID・パスワードが正しいか
        <br />
        ※大文字・小文字、全角入力にご注意ください。
      </li>
      <li className={styles.item}>
        推奨ブラウザを使用しているか
        <br />
        ※Google Chrome、Safari、Microsoft Edge（Chromium）を推奨しています。
      </li>
    </ul>
    <div>
      <p className={styles.heading}>【上記の手順で解決しなかった場合】</p>
      <p className={styles.text}>
        「Q.生徒のログインIDがわからない。生徒がパスワードを忘れてしまった」の項目をご確認ください。
      </p>
    </div>
  </div>
);

export const STUDENT_LOGIN_FAQ: FaqCategoryItem = {
  id: "student-login-faq",
  question: "生徒がログインできない",
  Answer,
};
